import script from "./CookieModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookieModal.vue?vue&type=script&lang=ts&setup=true"

import "./CookieModal.vue?vue&type=style&index=0&id=2e5a91b2&lang=scss"

const __exports__ = script;

export default __exports__